import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Task', prop: 'task' },
  { title: 'Position', prop: 'position' },
  { title: 'Day', prop: 'day_id', references: 'v1/days', referenceProp: 'date', format: 'date' },
  { title: 'Created', prop: 'created_at', format: 'date' },
  { title: 'Updated', prop: 'updated_at', format: 'date' }
]

const filters = [
  { name: 'Filter by homework', prop: 'filters.homework_id', type: 'autocomplete', references: 'admin/homeworks', referenceProp: 'title', enabled: true },
  { name: 'Filter by task', prop: 'filters.task_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [
    { column: 'position', direction: 'asc' },
    { column: 'updated_at', direction: 'desc' }
  ]
}

const HomeworkTasks = (props) => (
  <List
    title='Homework Tasks'
    apiPath={`admin/homework_tasks?homework_id=${props.params.homeworkId}`}
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
  />
)

export default HomeworkTasks
